export default class Dossier {
  constructor(data) {
    this.id = data.id;
    this.numero_dossier = data.numero_dossier;
    this.name = data.name;
    this.status = data.status;
    this.client = data.client;
    this.client_id = data.client_id;
    this.delegataire = data.ocr_delegataire;
    this.delegataire_id = data.ocr_delegataire_id;
    this.entreprise_id = data.entreprise_id;
    this.description = data.description;
    this.created_at = data.created_at;
    this.lock = data.lock;
    this.is_ready = data.is_ready;
    this.pipeline_tasks = data.pipeline_tasks || [];
    this.pipelines = data.pipelines || [];
    this.sous_pipelines = data.sous_pipelines || [];
  }
  update(data) {
    this.id = data.id;
    this.numero_dossier = data.numero_dossier;
    this.name = data.name;
    this.status = data.status;
    this.client = data.client;
    this.client_id = data.client_id;
    this.delegataire = data.ocr_delegataire;
    this.delegataire_id = data.ocr_delegataire_id;
    this.entreprise_id = data.entreprise_id;
    this.description = data.description;
    this.created_at = data.created_at;
    this.lock = data.lock;
    this.is_ready = data.is_ready;
    if (data.pipeline_tasks !== undefined) this.pipeline_tasks = data.pipeline_tasks || [];
    if (data.pipelines !== undefined) this.pipelines = data.pipelines || [];
    if (data.sous_pipelines !== undefined) this.sous_pipelines = data.sous_pipelines || [];
  }
  static create(data) {
    return new Dossier(data);
  }
}
